import { EventType, EventTypeDetailed } from "@/types";

import { axios } from "../axios.instance";

export type GetManagingEventRequest = {
  eventId: EventType["id"];
};

export type GetManagingEventResponse = EventType & EventTypeDetailed;

export const getManagingEvent = async (params: GetManagingEventRequest): Promise<GetManagingEventResponse> => {
  const { data } = await axios.get(`/events/manage/${params.eventId}`);

  return data;
};
